module.exports = "mutation deleteUser($id:String!){deleteUser(id:$id){email}}"